import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../styles/WhyNexa.css";

const Welcome = () => {
  return (
    <section className="Why-section">
      <div className="Why-container">
        <h2 className="entities-title">
          What makes us <span className="highlight">different?</span>
          <motion.div
            className="underline"
            layoutId="underline"
            transition={{ type: "spring", stiffness: 500, damping: 30 }}
          />
        </h2>
        <div className="Why-component">
          <div className="Welcome-image">
            <img src="/disc.png" alt="Office environment" />
          </div>
          <div className="Why-details">
            <h2 className="Why-heading">
              <span>African-Led, </span>{" "}
              <span className="light">Africa-Focused</span>
            </h2>
            <p className="Why-description">
              We understand the continent's unique challenges and immense
              opportunities. Our solutions are locally grounded and globally
              aligned. across the continent.
            </p>
          </div>
        </div>
        <div className="Why-component">
          <div className="Why-details">
            <h2 className="Why-heading">
              <span>People-Centered </span>{" "}
              <span className="light">Approach</span>
            </h2>
            <p className="Why-description">
              We don’t just build businesses. We build people. Our work is
              rooted in community, collaboration, and shared growth.
            </p>
          </div>
          <div className="Welcome-image">
            <img
              src="https://images.unsplash.com/photo-1653566031535-bcf33e1c2893?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Office environment"
            />
          </div>
        </div>
        <div className="Why-component">
          <div className="Welcome-image">
            <img src="https://images.unsplash.com/photo-1739285452644-3a2c009112fe?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Office environment" />
          </div>
          <div className="Why-details">
            <h2 className="Why-heading">
              <span>Results-Driven </span> <span className="light">Impact</span>
            </h2>
            <p className="Why-description">
              We are committed to measurable success — for individuals,
              enterprises, and Africa as a whole.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
